"use client";

import type { CommunityType } from "../../../../lib/types/enums/community/communityType";
import type { CommunitiesChildren } from "../../../../lib/types/schema/community/children/communitiesChildrenSchema";
import { communitiesChildrenSchema } from "../../../../lib/types/schema/community/children/communitiesChildrenSchema";
import { getRequestNextPageParam } from "../../../../lib/utils/getRequestNextPageParam";
import type { UseRequestInfiniteQueryProps } from "../../../../request/hooks/useRequestInfiniteQuery";
import { useRequestInfiniteQuery } from "../../../../request/hooks/useRequestInfiniteQuery";
import { keyCommunitiesChildren } from "./keyCommunitiesChildren";

export type UseRequestCommunitiesChildrenProps =
  UseRequestInfiniteQueryProps & {
    id: number;
    type: CommunityType;
  };

const REQUEST_COMMUNITIES_CHILDREN_PAGE_SIZE = 25;

export const useRequestCommunitiesChildren = ({
  id,
  type,
  ...props
}: UseRequestCommunitiesChildrenProps) => ({
  infiniteQuery: useRequestInfiniteQuery({
    getNextPageParam: (
      lastPage: CommunitiesChildren,
      _allPages: CommunitiesChildren[],
      lastPageParam: number,
    ) =>
      getRequestNextPageParam({
        total: lastPage.total,
        lastPageParam,
        pageSize: REQUEST_COMMUNITIES_CHILDREN_PAGE_SIZE,
      }),
    initialPageParam: 0,
    ...props,
    queryFnRequestProps: ({ pageParam }) => {
      return {
        schema: communitiesChildrenSchema,
        urlBackendPath: `/communities/${id}/children?page=${pageParam}&page_size=${REQUEST_COMMUNITIES_CHILDREN_PAGE_SIZE}&type=${type}`,
      };
    },
    queryKey: keyCommunitiesChildren({ id, type }),
  }),
});
